import { Content } from "@/services/content/types";

const getAuthors = (authors?: Content.Author[]) => {
  return authors?.reduce((acc: { [key: string]: string }, curr) => {
    if (curr.fields.name) {
      acc["article:author"] = curr.fields.name;
    }

    return acc;
  }, {});
};

const getTags = (tags?: string[]) => {
  return tags?.reduce((acc: { [key: string]: string }, curr) => {
    acc["article:tag"] = curr;

    return acc;
  }, {});
};

export const getMetadata = (
  item: Content.Article | Content.Play | Content.PodcastEpisode
) => {
  if (item.sys.contentType.sys.id === "article") {
    const article = item as Content.Article;

    const category = article.fields.categories?.[0];
    const authors = getAuthors(article.fields.authors) || {};
    const tags = getTags(article.fields.tags) || {};
    const type = article.fields.type || "Article";

    return {
      "article:section": "Finansmagasinet",
      "article:subsection": category?.fields.name,
      ...tags,
      "article:published_time": article.sys.createdAt,
      "article:modified_time": article.sys.updatedAt,
      ...authors,
      "k5a:contentTag": type,
    };
  }

  if (item.sys.contentType.sys.id === "play-episode") {
    const play = item as Content.Play;

    const show = play.fields["play-show"]?.fields.title;
    const authors = getAuthors(play.fields.participants) || {};
    const tags = getTags(play.fields.tags) || {};

    return {
      "article:section": "Play",
      "article:subsection": show,
      ...tags,
      "article:published_time": play.sys.createdAt,
      "article:modified_time": play.sys.updatedAt,
      ...authors,
      "k5a:contentTag": "Play",
    };
  }

  if (item.sys.contentType.sys.id === "play") {
    const play = item as Content.Play;

    const episode = play.fields.playEpisode?.fields.title;
    const authors = getAuthors(play.fields.participants) || {};
    const tags = getTags(play.fields.tags) || {};

    return {
      "article:section": "Play",
      "article:subsection": episode,
      ...tags,
      "article:published_time": play.sys.createdAt,
      "article:modified_time": play.sys.updatedAt,
      ...authors,
      "k5a:contentTag": "Play",
    };
  }

  if (item.sys.contentType.sys.id === "podcast-episode") {
    const podcast = item as Content.PodcastEpisode;

    const show = podcast.fields["podcast-show"]?.fields.title;
    const authors = getAuthors(podcast.fields.participants) || {};
    const tags = getTags(podcast.fields.tags) || {};

    return {
      "article:section": "Podd",
      "article:subsection": show,
      ...tags,
      "article:published_time": podcast.sys.createdAt,
      "article:modified_time": podcast.sys.updatedAt,
      ...authors,
      "k5a:contentTag": "Podd",
    };
  }
};

export const sendPageView = (item: Content.Article) => {
  if (item.sys.contentType.sys.id === "article") {
    const article = item as Content.Article;

    const image = article.fields.images?.[0].fields.file?.url
      ? `https:${article.fields.images[0].fields.file.url}`
      : "";

    const category = article.fields.categories?.[0].fields.name;
    const authors = article.fields.authors?.map((author) => author.fields.name);
    const tags = article.fields.tags;
    const type = article.fields.type || "Article";

    window.kilkaya?.pageview?.({
      url: `${process.env.NEXT_PUBLIC_FRONTEND_URL}/${article.fields.slug}`,
      title:
        article.fields.openGraphTitle ||
        article.fields.title ||
        article.fields.teaserTitle,
      type: "article",
      image: image,
      section: "Finansmagasinet",
      subsection: category,
      author: authors,
      tag: tags,
      modifiedtime: article.sys.updatedAt,
      publishtime: article.sys.createdAt,
      contentTag: [type],
    });
  }
};
